// @generated by protoc-gen-connect-es v1.1.2 with parameter "target=js+dts,import_extension=none"
// @generated from file checkout/fe/v1/checkout_fe_api.proto (package checkout.fe.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateSettingsSessionRequest, CreateSettingsSessionResponse, DeletePaymentProfilePaymentMethodRequest, DeletePaymentProfilePaymentMethodResponse, GetBinDataRequest, GetBinDataResponse, GetCheckoutSessionRequest, GetCheckoutSessionResponse, GetEncryptionKeyRequest, GetEncryptionKeyResponse, GetHostedFieldsSettingsRequest, GetHostedFieldsSettingsResponse, GetMerchantSettingsRequest, GetMerchantSettingsResponse, PayRequest, PayResponse, RequestApplePayPaymentSessionRequest, RequestApplePayPaymentSessionResponse, SendEventsRequest, SendEventsResponse, UpdateCartRequest, UpdateCartResponse, UpdateDefaultPaymentProfilePaymentMethodRequest, UpdateDefaultPaymentProfilePaymentMethodResponse } from "./checkout_fe_api_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service checkout.fe.v1.CheckoutFrontendV1Service
 */
export const CheckoutFrontendV1Service = {
  typeName: "checkout.fe.v1.CheckoutFrontendV1Service",
  methods: {
    /**
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.GetMerchantSettings
     */
    getMerchantSettings: {
      name: "GetMerchantSettings",
      I: GetMerchantSettingsRequest,
      O: GetMerchantSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.GetEncryptionKey
     */
    getEncryptionKey: {
      name: "GetEncryptionKey",
      I: GetEncryptionKeyRequest,
      O: GetEncryptionKeyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.GetHostedFieldsSettings
     */
    getHostedFieldsSettings: {
      name: "GetHostedFieldsSettings",
      I: GetHostedFieldsSettingsRequest,
      O: GetHostedFieldsSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * TODO: find better name, i.e. "CompleteCheckout(Intent)?" / "FinalizeCheckout(Intent)?"
     *
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.Pay
     */
    pay: {
      name: "Pay",
      I: PayRequest,
      O: PayResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Request an Apple Pay Payment Session.
     *
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.RequestApplePayPaymentSession
     */
    requestApplePayPaymentSession: {
      name: "RequestApplePayPaymentSession",
      I: RequestApplePayPaymentSessionRequest,
      O: RequestApplePayPaymentSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get checkout session info
     *
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.GetCheckoutSession
     */
    getCheckoutSession: {
      name: "GetCheckoutSession",
      I: GetCheckoutSessionRequest,
      O: GetCheckoutSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * TODO: To be removed once UI integration with backend completes - MPP
     *
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.CreateSettingsSession
     */
    createSettingsSession: {
      name: "CreateSettingsSession",
      I: CreateSettingsSessionRequest,
      O: CreateSettingsSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Sends frontend UI events such as user interactions to the backend service.
     *
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.SendEvents
     */
    sendEvents: {
      name: "SendEvents",
      I: SendEventsRequest,
      O: SendEventsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.UpdateCart
     */
    updateCart: {
      name: "UpdateCart",
      I: UpdateCartRequest,
      O: UpdateCartResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes the payment method of the PaymentProfile
     *
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.DeletePaymentProfilePaymentMethod
     */
    deletePaymentProfilePaymentMethod: {
      name: "DeletePaymentProfilePaymentMethod",
      I: DeletePaymentProfilePaymentMethodRequest,
      O: DeletePaymentProfilePaymentMethodResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns the bin details for the encrypted pan - CB entitlement & debit enabled
     *
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.GetBinData
     */
    getBinData: {
      name: "GetBinData",
      I: GetBinDataRequest,
      O: GetBinDataResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates the default payment method of the PaymentProfile
     *
     * @generated from rpc checkout.fe.v1.CheckoutFrontendV1Service.UpdateDefaultPaymentProfilePaymentMethod
     */
    updateDefaultPaymentProfilePaymentMethod: {
      name: "UpdateDefaultPaymentProfilePaymentMethod",
      I: UpdateDefaultPaymentProfilePaymentMethodRequest,
      O: UpdateDefaultPaymentProfilePaymentMethodResponse,
      kind: MethodKind.Unary,
    },
  }
};

